<h2 mat-dialog-title>Verificación en dos pasos</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Código 2FA</mat-label>
    <input
      matInput
      [formControl]="codigoControl"
      maxlength="6"
      autocomplete="one-time-code"
    />
    <mat-error *ngIf="codigoControl.hasError('required')">
      Ingresa el código
    </mat-error>
    <mat-error *ngIf="codigoControl.hasError('invalid') || codigoControl.hasError('pattern')">
      Código incorrecto
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button color="primary" (click)="validar()" [disabled]="codigoControl.invalid">
    Validar
  </button>
</mat-dialog-actions>